module.exports = __webpack_public_path__ + "static/media/slider-img2.5de387aa.PNG";